import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import authRoutes from '@/core/router/auth'
import { createDefaultRouter } from '@/core/router/default'
import { resolveAuthNavigation } from '@/core/auth/guards'
import {
  extractFeedbackLinkId,
  isFeedbackAllowedRouteName,
  isFeedbackHost,
} from '@/core/router/feedbackHost'

const routes: Array<RouteRecordRaw> = [...authRoutes]

const router = createRouter({
    history: createWebHistory(),
    routes
})

createDefaultRouter(router)

router.beforeEach((to, _from, next) => {
    // feedback.farsroute.com: only public feedback pages (no CRM auth/UI)
    if (isFeedbackHost()) {
      if (isFeedbackAllowedRouteName(to.name)) {
        next()
        return
      }

      const linkId = extractFeedbackLinkId(to.path)
      if (linkId) {
        next({ name: 'FeedbackPublic', params: { linkId }, replace: true })
        return
      }

      next({ name: 'FeedbackHome', replace: true })
      return
    }

    const decision = resolveAuthNavigation(to)
    if (decision !== true) {
      next(decision)
      return
    }

    next()
})

router.onError((error, to) => {
  const msg = String(error?.message || '')
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('error loading dynamically imported module')
  ) {
    const target = to?.fullPath || window.location.pathname
    const key = `chunk_reload_${target}`
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1')
      window.location.assign(target)
    }
  }
})

export default router
